import type { DeleteAssessmentsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  DeleteAssessmentsDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteAssessment = createMutationHook({
  name: 'deleteAssessment',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.assessment.delete.mutationOptions({ onSuccess }),
  mapInput: (id: string) => ({ id }),
  invalidate: (trpc) => [
    trpc.frontend.assessment.register.queryKey(),
    trpc.frontend.assessment.getById.queryKey(),
    trpc.frontend.assessment.activityRegister.queryKey(),
    trpc.frontend.assessment.resultsRegister.queryKey(),
  ],
  // trpc should throw an error if no rows are affected
  mapResponse: (): DeleteAssessmentsMutation => ({
    delete_assessment: {
      __typename: 'assessment_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteAssessmentsDocument,
  graphqlVariables: (id: string) => ({ Ids: [id] }),
  evictFields: ['assessment', 'assessment_aggregate'],
  refetchQueries: [
    namedOperations.Query.getAssessmentById,
    namedOperations.Query.getAssessments,
  ],
});
